import { render } from "./BottomPagination.vue?vue&type=template&id=4ac6bc49&scoped=true&lang=pug"
import script from "./BottomPagination.vue?vue&type=script&lang=js"
export * from "./BottomPagination.vue?vue&type=script&lang=js"

import "./BottomPagination.vue?vue&type=style&index=0&id=4ac6bc49&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac6bc49"]])

export default __exports__